import { ComponentPropsWithoutRef } from 'react';

import classNames from 'classnames';

import KarmaPoint from '@uikit/icons/KarmaPoint';

export interface KarmaTagProps extends ComponentPropsWithoutRef<'div'> {
  points: string | number;
  iconClassName?: string;
  approxSign?: boolean;
}

function KarmaTag({ points = 0, iconClassName, className, approxSign, ...props }: KarmaTagProps) {
  return (
    <div
      className={classNames(
        'tag tag-sm tag-karma text-sm text-neutral-50 bg-secondary-700',
        className,
      )}
      {...props}
      data-qa="karma-row-karma"
    >
      <KarmaPoint className={classNames('icon', iconClassName)} />
      {approxSign && '≈'}
      {points}
    </div>
  );
}

export default KarmaTag;
